import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { ForgotPassword } from './pages/ForgotPassword';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<Login data-id="element-5" />} data-id="element-4" />
        <Route path="/signup" element={<Signup data-id="element-7" />} data-id="element-6" />
        <Route path="/forgot-password" element={<ForgotPassword data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}